export const isLoadingReturnToProvisionSelector = state => state.returnToProvision.returnToProvisionLoading;
